export default class BankInfoModel {
  constructor() {
    this.bankId = Math.uuidFast();
    // 銀行
    this.title = '';
    // 分行
    this.subTitle = '';
    // 戶名
    this.name = '';
    // 帳戶
    this.account = '';
    // 結餘
    this.balance = 0;
    // 0:一般 1:常用
    this.favorite = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/BankInfoModel.js